import { useQuery } from "react-query";
import SkillsReportsService from "./SkillsReportsService";
import http from "../../../../../core/utils/apis/skillApi";

const useSkillsReports = () => {
  const { data: rawData, isLoading: loadingTopSkills } = useQuery(
    "topSkillsByDepartment",
    SkillsReportsService.getTopSkillsByDepartment
  );

  const { data: skillLevelsDistribution, isLoading: loadingSkillLevels } =
    useQuery(
      "skillLevelsDistribution",
      SkillsReportsService.getSkillLevelsDistribution
    );

  const {
    data: skillDistributionByCategory,
    isLoading: loadingSkillDistribution,
  } = useQuery(
    "skillDistributionByCategory",
    SkillsReportsService.getSkillDistributionByCategory
  );

  const { data: skillCategoriesData, isLoading: loadingSkillCategories } =
    useQuery("skillCategories", SkillsReportsService.getSkillCategories);

  const { data: departmentsData, isLoading: loadingDepartments } = useQuery(
    "departments",
    async () => {
      const res = await http.get("/users/departments");
      return res.data;
    }
  );

  const {
    data: skillAcquisitionProgressData,
    isLoading: loadingSkillAcquisition,
  } = useQuery(
    "skillAcquisitionProgress",
    SkillsReportsService.getSkillAcquisitionProgress
  );

  const fetchSkillLevelsByCategoriesAndTeams = async (categories, teams) => {
    const params = new URLSearchParams();

    categories.forEach((cat) => params.append("categories", cat));
    teams.forEach((team) => params.append("teams", team));

    const queryString = params.toString(); 

    const res = await http.get(
      `/skills-reports/level-distribution/filter?${queryString}`
    );
    return res.data;
  };
  const { data: manualRequestsStats, isLoading: loadingManualStats } = useQuery(
    "manualRequestsStats",
    SkillsReportsService.getManualRequestsStats
  );

  const { data: certifiedRequestsStats, isLoading: loadingCertifiedStats } =
    useQuery(
      "certifiedRequestsStats",
      SkillsReportsService.getCertifiedRequestsStats
    );
  const { data: manualRequestsByDept, isLoading: loadingManualByDept } =
    useQuery(
      "manualRequestsByDepartment",
      SkillsReportsService.getRequestsByDepartment
    );

  const { data: certifiedRequestsByDept, isLoading: loadingCertifiedByDept } =
    useQuery(
      "certifiedRequestsByDepartment",
      SkillsReportsService.getCertifiedRequestsByDepartment
    );

  return {
    rawTopSkillsData: rawData?.data || [],
    loadingTopSkills,
    skillLevelsDistribution: skillLevelsDistribution?.data || [],
    loadingSkillLevels,
    skillDistributionByCategory: skillDistributionByCategory?.data || [],
    loadingSkillDistribution,
    skillCategories: skillCategoriesData?.data || [],
    loadingSkillCategories,
    departments: departmentsData || [],
    loadingDepartments,
    skillAcquisitionProgress: skillAcquisitionProgressData?.data || [],
    loadingSkillAcquisition,
    fetchSkillLevelsByCategoriesAndTeams,
    manualRequestsStats: manualRequestsStats?.data || {},
    certifiedRequestsStats: certifiedRequestsStats?.data || {},
    loadingManualStats,
    loadingCertifiedStats,
    manualRequestsByDept: manualRequestsByDept?.data || [],
    loadingManualByDept,
    certifiedRequestsByDept: certifiedRequestsByDept?.data || [],
    loadingCertifiedByDept,
  };
};

export default useSkillsReports;
